import { render, staticRenderFns } from "./ShopXqDetile.vue?vue&type=template&id=1ff427c8&"
import script from "./ShopXqDetile.vue?vue&type=script&lang=js&"
export * from "./ShopXqDetile.vue?vue&type=script&lang=js&"
import style0 from "./ShopXqDetile.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports